import './css/index.css';
import './css/loader.css';
import './css/responsive.css';

import App from "./App";

// @todo Workaround: iOS overlays navigation bars in landscape and the page is not scrollable due
//       to 3D interaction, as a result the bottom part of the page is not visible
window.addEventListener("resize", function () {
    if (window.innerHeight < document.documentElement.clientHeight) {
        // Make sure the top of the page is displayed and modify it's height to fit within the visible area
        window.scrollTo(0, 0);
        document.body.style.maxHeight = window.innerHeight + "px";
    } else {
        document.body.style.maxHeight = "";
    }
});

window.addEventListener("load", function () {
    let app = new App();

    // @todo Hack to expose App to enable it to be called from ModelPicker when a panorama is activated
    window.app = app;

    // @todo Need to implement some form of parameter/server-side routing, this is currently limited to only work on the dev server. Example: 'https://localhost:3000/my-config'
    // let pathname   = (window.location.pathname || '').replace(/^[/]+/, '');
    // let configName = pathname !== "" ? pathname : "DemoHouse_02";

    // Using the GET parameter config. Example https://example.com/configurator/index.html?config=DemoHouse
    let configPath = /[?&]{1}config=([^&]+)/.exec(window.location.href);
    configPath = configPath && configPath.length > 1 ? configPath[1] : '';

    let configName = configPath !== "" ? configPath : "DemoHouse_03";

    app.loadConfig("config/" + configName + ".json")
       .then(
           () => { /* no-op */},
           // Fallback to default if not exists
           () => app.loadConfig("config/default.json")
       ).then(() => app.init());
});



// WEBPACK FOOTER //
// ./src/index.js